import { Outlet } from 'react-router-dom';
import { PublicNav, PublicFooter, PublicMobileNav } from '@/components/portal';

function PublicLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
      >
        Skip to main content
      </a>
      <PublicNav />
      <main id="main-content" className="flex-1 pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0">
        {children ?? <Outlet />}
      </main>
      <PublicFooter />
      <PublicMobileNav />
    </div>
  );
}

export default PublicLayout;
